import { ReactTransition } from 'components/react-trasition-group/ReactTransitionGroup';
import { useEffect, useRef, useState, memo } from 'react';

interface MenuContainerProps {
  className?: string;
  data?: any;
  row?: any;
  TitleComponent?: any;
  ChildComponent?: any;
  transitionClass?: string;
  id?: string;
}

const MenuContainer = ({
  className,
  TitleComponent,
  ChildComponent,
  transitionClass = 'transition',
  id,
}: MenuContainerProps): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    // Close on any click except the title trigger (which toggles instead).
    // Menu action items rely on this document-level close instead of calling
    // setIsOpen(false) themselves.
    const closeOnOutsideClick = (event: MouseEvent) => {
      if (!inputRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    const handleContextMenu = (event: MouseEvent) => {
      if (inputRef.current?.contains(event.target as Node)) {
        event.preventDefault();
        setIsOpen(currentIsOpen => !currentIsOpen);
      } else if (!containerRef.current?.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', closeOnOutsideClick);
    document.addEventListener('contextmenu', handleContextMenu);
    return () => {
      document.removeEventListener('click', closeOnOutsideClick);
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  function toggle(event: any) {
    event?.preventDefault();
    setIsOpen(currentIsOpen => !currentIsOpen);
  }

  return (
    <div className={className} id={id} ref={containerRef}>
      <TitleComponent ref={inputRef} toggle={toggle} onTitleClickHandler={toggle} isOpen={isOpen} />
      <ReactTransition flag={isOpen} timeout={800} classNames={transitionClass}>
        {ChildComponent ? (
          <ChildComponent isOpen={isOpen} setIsOpen={setIsOpen} />
        ) : (
          <div style={{ display: 'none' }} />
        )}
      </ReactTransition>
    </div>
  );
};

export default memo(MenuContainer);
